module.exports = __webpack_public_path__ + "static/media/volunteer-ken.17a912e3.jpg";